<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="payInfo">
    <PlateTitle title="请及时完成支付">
      <template v-slot:subtitle>
        <span class="subtitle">业务流水号：{{ orderNo }}</span>
      </template>
    </PlateTitle>
    <div class="main">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="您的保额（元）" has-feedback>
          <span>¥{{ infoJson.amount }}</span>
        </a-form-item>
        <a-form-item label="需支付保费（元）" has-feedback>
          <span>¥{{ infoJson.premium }}</span>
        </a-form-item>
      </a-form>
    </div>
    <PlateTitle title="请点击选择支付方式" />
    <div class="pay_info">
      <div @click="handeClick(infoJson.zfbPayBase64, 1)" class="info_box">
        <div class="head_s">支付宝支付</div>
        <div class="logo">
          <img v-if="!zfbImg" src="../../assets/image/pic_zfbzf.png" alt="" />
          <img v-else :src="zfbImg" alt="" />
        </div>
      </div>
      <div @click="handeClick(infoJson.wechatPayBase64, 2)" class="info_box">
        <div class="head_s">微信支付</div>
        <div class="logo">
          <img v-if="!wxImg" src="../../assets/image/pic_wxzf.png" alt="" />
          <img v-else :src="wxImg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlateTitle from "@/components/PlateTitle";
import { getBase64 ,getPaymentInfo} from "./api.js";
export default {
  components: {
    PlateTitle,
  },
  data() {
    return {
      infoJson: {},
      orderNo: "",
      wxImg: "",
      zfbImg: "",
    };
  },
  mounted() {
    this.init();
    this.orderNo = this.getQueryString("orderNo");
  },
  methods: {
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    async init() {
      this.orderNo = this.getQueryString("orderNo");
      const { data: data } = await getPaymentInfo({
        orderNo: this.orderNo,
        platformType: 3,
      });
      this.infoJson = data.data;
    },
    handeClick(url, val) {
      getBase64(url).then(({ data: data }) => {
        if (val == 1) {
          this.zfbImg = data.data.qrcode;
        } else {
          this.wxImg = data.data.qrcode;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.payInfo {
  width: 1200px;
  min-height: 700px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 124, 226, 0.03);
  border-radius: 2px 2px 2px 2px;
  margin: auto;
  margin-top: 24px;
  padding: 40px 30px 0 30px;
  .subtitle {
    font-size: 14px;
    line-height: 28px;
  }
  ::v-deep .ant-form-item-label {
    width: 192px;
    padding-left: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-right: 10px;
  }
  ::v-deep .ant-form-item-children {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  /deep/ .ant-form-item {
    margin-bottom: 10px !important;
  }
  .main {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .pay_info {
    display: flex;
    .info_box {
      width: 380px;
      height: 400px;
      background: #ffffff;
      box-shadow: 5px 15px 30px 5px rgba(75, 111, 158, 0.15);
      border-radius: 5px 5px 5px 5px;
      margin-right: 20px;
      cursor: pointer;
      .head_s {
        padding-top: 40px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .logo {
        margin: auto;
        width: 150px;
        height: 150px;
        margin-top: 33px;
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
  }
}
</style>
